import React from 'react'
import { Contenedorimagen } from './ContenedorImagen'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { Contenedor } from './Contenedor'
import Navbar2 from './Navbar'
import "../Appv2"
import "../inicio.css"

function Inicio() {
    return (
        <div className='app2 rs-inicio-page'>
            <Navbar2 className=""/>
            <Contenedorimagen className="imagen rs-inicio-bg">
                <Contenedor className='rs-inicio-shell'>
                    <section className='rs-inicio-card'>
                        <span className='rs-inicio-chip'>Centro Cívico Gubernamental</span>
                        <h1 className='rs-inicio-title'>Sistema de Reserva de Salas</h1>
                        <p className='rs-inicio-copy'>
                            La presente página web permite gestionar reservas de salas en los diferentes edificios,
                            facilitando la coordinación entre usuarios y administradores con mayor orden,
                            transparencia y seguimiento de cada solicitud.
                        </p>

                        <div className='rs-inicio-grid'>
                            <article className='rs-inicio-item'>
                                <h4>Edificios Integrados</h4>
                                <p>Torre 1, Torre 2, CBB y CBC</p>
                            </article>
                            <article className='rs-inicio-item'>
                                <h4>Gestión Eficiente</h4>
                                <p>Solicitudes, revisión, confirmación y cancelación en un solo flujo</p>
                            </article>
                            <article className='rs-inicio-item'>
                                <h4>Visibilidad Total</h4>
                                <p>Control de disponibilidad por fecha, sala y horario</p>
                            </article>
                        </div>
                    </section>

                    <aside className='rs-inicio-visual'>
                        <div className='rs-icon-wrap'>
                            <FontAwesomeIcon icon={faEdit} />
                        </div>
                        <p className='rs-visual-text'>
                            Organiza tus espacios de reunión con una experiencia más clara y rápida.
                        </p>
                    </aside>
                </Contenedor>
            </Contenedorimagen>
        </div>

    )
}

export default Inicio
